import { Api } from '@shared-providers/api.provider';
import { Injectable } from '@angular/core';
import { Provider } from '@shared-providers/Provider';
import { LoadingService } from '@shared-services/loading.service';
import { IAddress } from '@shared-models/address.model';

@Injectable({
	providedIn: 'root',
})
export class AddressProvider extends Provider<IAddress> {
	protected readonly url: string = '/addresses';

	constructor(
		protected readonly api: Api,
		protected readonly loadingService: LoadingService
	) {
		super(loadingService);
	}

	public autocomplete(address: string): Promise<Array<{ description: string; id: string }>> {
		return this.process(this.api.get(`${this.url}/autocomplete?address=${address}`), false) as Promise<
			Array<{ description: string; id: string }>
		>;
	}

	public getAutocompleteAddressById(id: string): Promise<IAddress> {
		return this.process(this.api.get(`${this.url}/autocomplete/${id}`), false) as Promise<IAddress>;
	}
}
